
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/windsurfer",
      function () {
        return require("private-next-pages/games/windsurfer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/windsurfer"])
      });
    }
  